/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/books.scss';
import Tab from '../../component/Inc/Tab';

const RefundBook = () => {
  const [tabIdx, setTabIdx] = useState(0);
  const [tabIdx02, setTabIdx02] = useState(0);
  const tab = [
    {title: '발송', value: 0},
    {title: '반품', value: 1},
    {title: '오입력', value: 2}
  ];
  const tab02 = [
    {title: '전체', value: 0},
    {title: '판매', value: 1},
    {title: '판매종료', value: 2}
  ];
  return (
    <main className="com_container com_books p_refund_book">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu3_11">총판 교재 발송 / 반품</h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus">총판 관리</button>
            <button className="com_btn orange s btn_settings">교재 관리</button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box box-half">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
            </div>
            <div className="default_tit bold">1. 총판 선택</div>
            <table className="com_board_list">
              <colgroup>
                <col width="60" />
                <col width="170" />
                <col width="200" />
                <col width="200" />
                <col width="auto" />
              </colgroup>
              <thead>
                <tr>
                  <th>선택</th>
                  <th>
                    총판명 &nbsp;
                    <button className="arrow active" />
                  </th>
                  <th>대표 전화</th>
                  <th>담당자</th>
                  <th>
                    <div className="info">
                      <span>납품가</span>
                      <span className="bar" />
                      <span>채택가</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td>서울 제일총판</td>
                  <td>02-1234-3240</td>
                  <td>
                    김담당
                    <br />
                    010-1234-1322
                  </td>
                  <td>
                    <div className="info">
                      <span className="txt">50%</span>
                      <span className="bar" />
                      <span className="txt">40%</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td>서울 제일총판</td>
                  <td>02-1234-3240</td>
                  <td>
                    김담당
                    <br />
                    010-1234-1322
                  </td>
                  <td>
                    <div className="info">
                      <span className="txt">50%</span>
                      <span className="bar" />
                      <span className="txt">40%</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td>서울 제일총판</td>
                  <td>02-1234-3240</td>
                  <td>
                    김담당
                    <br />
                    010-1234-1322
                  </td>
                  <td>
                    <div className="info">
                      <span className="txt">50%</span>
                      <span className="bar" />
                      <span className="txt">40%</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td>서울 제일총판</td>
                  <td>02-1234-3240</td>
                  <td>
                    김담당
                    <br />
                    010-1234-1322
                  </td>
                  <td>
                    <div className="info">
                      <span className="txt">50%</span>
                      <span className="bar" />
                      <span className="txt">40%</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="com_btn_wrap">
              <div className="com_btn black xs btn_plus_orange">선택한 학생 교재 교부</div>
            </div>
            <div className="default_tit bold tit_margin">2. 교재 선택</div>
            <div className="com_board_list__top">
              <Tab data={tab02} tab={tabIdx02} setTab={setTabIdx02} tabStyle="fit_cont" />
              <section className="com_board_search">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="btn_wrapper">
              <button className="com_btn black xxs">국어</button>
              <button className="com_btn lightGray xxs">영어</button>
              <button className="com_btn lightGray xxs">수학</button>
              <button className="com_btn lightGray xxs">사탐</button>
              <button className="com_btn lightGray xxs">과탐</button>
              <button className="com_btn lightGray xxs">논술</button>
              <button className="com_btn lightGray xxs">면접</button>
              <button className="com_btn lightGray xxs">생디</button>
            </div>

            <div className="checkbox_wrap">
              <div className="check">
                <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                <label htmlFor="chk01">전체</label>
                <input type="checkbox" name="chk" id="chk02" className="com_chk" />
                <label htmlFor="chk02">공식집</label>
                <input type="checkbox" name="chk" id="chk03" className="com_chk" />
                <label htmlFor="chk03">개념끝장</label>
                <input type="checkbox" name="chk" id="chk04" className="com_chk" />
                <label htmlFor="chk04">내신유형서</label>
                <input type="checkbox" name="chk" id="chk05" className="com_chk" />
                <label htmlFor="chk05">한권</label>
                <input type="checkbox" name="chk" id="chk06" className="com_chk" />
                <label htmlFor="chk06">이지웨이</label>
                <input type="checkbox" name="chk" id="chk07" className="com_chk" />
                <label htmlFor="chk07">기출리허설</label>
                <input type="checkbox" name="chk" id="chk08" className="com_chk" />
                <label htmlFor="chk08">모의고사</label>
                <input type="checkbox" name="chk" id="chk09" className="com_chk" />
                <label htmlFor="chk09">시크릿</label>
              </div>
            </div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="60" />
                  <col width="170" />
                  <col width="auto" />
                </colgroup>
                <thead>
                  <tr>
                    <th>선택</th>
                    <th>코드</th>
                    <th>교재명</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <input type="checkbox" id="chk00" className="com_chk" />
                      <label htmlFor="chk00"></label>
                    </td>
                    <td>1234</td>
                    <td className="td_left">개념끝장 고등수학(상)</td>
                  </tr>
                  <tr>
                    <td>
                      <input type="checkbox" id="chk00" className="com_chk" />
                      <label htmlFor="chk00"></label>
                    </td>
                    <td>1234</td>
                    <td className="td_left">개념끝장 고등수학(상)</td>
                  </tr>
                  <tr>
                    <td>
                      <input type="checkbox" id="chk00" className="com_chk" />
                      <label htmlFor="chk00"></label>
                    </td>
                    <td>1234</td>
                    <td className="td_left">개념끝장 고등수학(상)</td>
                  </tr>
                  <tr>
                    <td>
                      <input type="checkbox" id="chk00" className="com_chk" />
                      <label htmlFor="chk00"></label>
                    </td>
                    <td>1234</td>
                    <td className="td_left">개념끝장 고등수학(상)</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="com_btn_wrap">
              <div className="com_btn black xs btn_plus_orange">선택한 교재 발송목록에 추가</div>
            </div>
          </section>
          <section className="box box-half">
            <div className="detail_tit dot">발송 목록</div>
            <div className="com_info">
              <p className="name">서울제일 총판</p>
              <p className="date dot">김담당 010-1234-312234ㆍ50%ㆍ 40%</p>
              <div className="count">
                <button type="button" className="btn_del_file"></button>
              </div>
            </div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="60" />
                  <col width="80" />
                  <col width="80" />
                  <col width="auto" />
                  <col width="100" />
                  <col width="140" />
                  <col width="100" />
                </colgroup>
                <thead>
                  <tr>
                    <th>선택</th>
                    <th>코드</th>
                    <th>대표 전화</th>
                    <th>담당자</th>
                    <th>판매가</th>
                    <th>비고</th>
                    <th>보낼 권 수</th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(5)].map((i, idx) => (
                    <tr key={idx}>
                      <td>
                        <button className="btn_del_file"></button>
                      </td>
                      <td>12344</td>
                      <td>수학</td>
                      <td>개념끝장 고등수학(상)</td>
                      <td>45,000</td>
                      <td>
                        <div className="com_input_wrap flex_row gap">
                          <div className="check">
                            <input type="radio" name={`rdo${idx}`} id={`rdo${idx}1`} className="com_chk circle" />
                            <label htmlFor={`rdo${idx}1`}>공급</label>
                          </div>
                          <div className="check">
                            <input type="radio" name={`rdo${idx}`} id={`rdo${idx}2`} className="com_chk circle" />
                            <label htmlFor={`rdo${idx}2`}>채택</label>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="com_btn line lightGray xs">30</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="com_info">
              <p className="name">경기도 총판</p>
              <p className="date dot">김담당 010-1234-312234ㆍ50%ㆍ 40%</p>
              <div className="count">
                <button type="button" className="btn_del_file"></button>
              </div>
            </div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="60" />
                  <col width="80" />
                  <col width="80" />
                  <col width="auto" />
                  <col width="100" />
                  <col width="140" />
                  <col width="100" />
                </colgroup>
                <thead>
                  <tr>
                    <th>선택</th>
                    <th>코드</th>
                    <th>대표 전화</th>
                    <th>담당자</th>
                    <th>판매가</th>
                    <th>비고</th>
                    <th>보낼 권 수</th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(5)].map((i, idx) => (
                    <tr key={idx}>
                      <td>
                        <button className="btn_del_file"></button>
                      </td>
                      <td>12344</td>
                      <td>수학</td>
                      <td>개념끝장 고등수학(상)</td>
                      <td>45,000</td>
                      <td>
                        <div className="com_input_wrap flex_row gap">
                          <div className="check">
                            <input type="radio" name={`rdo${idx}`} id={`rdo${idx}1`} className="com_chk circle" />
                            <label htmlFor={`rdo${idx}1`}>공급</label>
                          </div>
                          <div className="check">
                            <input type="radio" name={`rdo${idx}`} id={`rdo${idx}2`} className="com_chk circle" />
                            <label htmlFor={`rdo${idx}2`}>채택</label>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="com_btn line lightGray xs">30</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="com_info">
              <p className="name">부산 총판</p>
              <p className="date dot">김담당 010-1234-312234ㆍ50%ㆍ 40%</p>
              <div className="count">
                <button type="button" className="btn_del_file"></button>
              </div>
            </div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="60" />
                  <col width="80" />
                  <col width="80" />
                  <col width="auto" />
                  <col width="100" />
                  <col width="140" />
                  <col width="100" />
                </colgroup>
                <thead>
                  <tr>
                    <th>선택</th>
                    <th>코드</th>
                    <th>대표 전화</th>
                    <th>담당자</th>
                    <th>판매가</th>
                    <th>비고</th>
                    <th>보낼 권 수</th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(5)].map((i, idx) => (
                    <tr key={idx}>
                      <td>
                        <button className="btn_del_file"></button>
                      </td>
                      <td>12344</td>
                      <td>수학</td>
                      <td>개념끝장 고등수학(상)</td>
                      <td>45,000</td>
                      <td>
                        <div className="com_input_wrap flex_row gap">
                          <div className="check">
                            <input type="radio" name={`rdo${idx}`} id={`rdo${idx}1`} className="com_chk circle" />
                            <label htmlFor={`rdo${idx}1`}>공급</label>
                          </div>
                          <div className="check">
                            <input type="radio" name={`rdo${idx}`} id={`rdo${idx}2`} className="com_chk circle" />
                            <label htmlFor={`rdo${idx}2`}>채택</label>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="com_btn line lightGray xs">30</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <span className="txt com_red_txt center_align">* 교재 요청 후 15일 이내 수령하지 않으면 자동 삭제 됩니다.</span>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange xs">교재 불출 요청</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default RefundBook;
